import { DI } from '@intigral/constant/config/DIContainer';
import { Container } from '../../../DIContainer';
import { GetSearchPAUseCase } from './GetSearchPAUseCase';
import { GetSearchSuggestionsUseCase } from './GetSearchSuggestionsUseCase';
import { GetBecauseYouWatchedMultipleUseCase } from './getBecauseYouWatchedMultiple';
import { GetRelatedUseCase } from './getRelated';
import { GetRelatedOthersUseCase } from './getRelatedOthers';
import { GetTAFeedUseCase } from './getTAFeedUseCase';
import { GetVodListAndYouWatchedUseCase } from './getVodListAndYouWatched';
import { GetFeelingLuckyUseCase } from './GetFeelingLuckyUseCase';
import { GetMoodVodUseCase } from './GetMoodVodUseCase';
import { GetZoneUseCase } from './GetZoneUseCase';

export const initializeThinkAnalyticsUseCases = (container: Container) => {
    container.register(DI.USECASES.IGetSearchSuggestionsUseCase, {
        useClass: GetSearchSuggestionsUseCase,
    });
    container.register(DI.USECASES.IGetSearchPAUseCase, {
        useClass: GetSearchPAUseCase,
    });
    container.register(DI.USECASES.IGetBecauseYouWatchedMultipleUseCase, {
        useClass: GetBecauseYouWatchedMultipleUseCase,
    });
    container.register(DI.USECASES.IGetRelatedUseCase, {
        useClass: GetRelatedUseCase,
    });
    container.register(DI.USECASES.IGetRelatedOthersUseCase, {
        useClass: GetRelatedOthersUseCase,
    });
    container.register(DI.USECASES.IGetVodListAndYouWatchedUseCase, {
        useClass: GetVodListAndYouWatchedUseCase,
    });
    container.register(DI.USECASES.IGetTAFeedUseCase, {
        useClass: GetTAFeedUseCase,
    });
    container.register(DI.USECASES.IGetFeelingLuckyUseCase, {
        useClass: GetFeelingLuckyUseCase,
    });
    container.register(DI.USECASES.IGetMoodVodUseCase, {
        useClass: GetMoodVodUseCase,
    });
    container.register(DI.USECASES.IGetZoneUseCase, {
        useClass: GetZoneUseCase,
    });
};
